import React from 'react';
import { Nav } from 'shards-react';
import UserActions from './UserActions';
import Help from './Help';

const NavbarNav = () => (
	<Nav navbar className='flex-row'>
        <Help />
		<UserActions />
	</Nav>
);

export default NavbarNav;
